import { InjectionToken, ModuleWithProviders, NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
export const DYNAMIC_REPORT_PREFIX_URL = new InjectionToken<string>('DYNAMIC_REPORT_PREFIX_URL');
export const DYNAMIC_REPORT_ORIGIN = new InjectionToken<string>('DYNAMIC_REPORT_ORIGIN');
@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
})
export class DynamicReportGeneralModule {
  static forRoot(configs?: { prefix?: string; origin?: string }): ModuleWithProviders<DynamicReportGeneralModule> {
    const valueProviders: ValueProvider[] = [
      {
        provide: DYNAMIC_REPORT_PREFIX_URL,
        useValue: configs?.prefix || '',
      },
      {
        provide: DYNAMIC_REPORT_ORIGIN,
        useValue: configs?.origin || '',
      },
    ];
    return {
      ngModule: DynamicReportGeneralModule,
      providers: [...valueProviders],
    };
  }
  static forFeature(configs: { prefix: string }): ModuleWithProviders<DynamicReportGeneralModule> {
    const valueProviders: ValueProvider[] = [
      {
        provide: DYNAMIC_REPORT_PREFIX_URL,
        useValue: configs?.prefix || '',
      },
    ];
    return {
      ngModule: DynamicReportGeneralModule,
      providers: [...valueProviders],
    };
  }
}
